import { useQuery } from 'react-query';

import Api from '../Services/Api';
import { Post } from '../Utils/Types/Posts';
import useCurrentUser from './useCurrentUser';

interface PostsQueryResponse {
  posts: Post[];
  paging: any;
  postsCount: number;
  isFetching: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
  error: any;
}

const usePostsQuery = (
  key: any,
  {
    assigneeId = '',
    authorId = '',
    extraParams,
    iVotedFor,
    limit,
    page = 0,
    parentId = [],
    post,
    search = '',
    sort,
    space,
    status,
    tags = [],
    types,
    useQueryProps,
    visibilities = [],
  }: any,
): PostsQueryResponse => {
  // Note: Posts return permissions based on the current user
  // so we need to refetch the post when the user changes
  const { currentUser } = useCurrentUser();

  const { data, ...params } = useQuery(
    [
      ...(Array.isArray(key) ? key : [key]),
      currentUser?.id,
      assigneeId,
      authorId,
      extraParams,
      iVotedFor,
      page,
      parentId,
      post,
      search,
      sort,
      status,
      tags,
      types,
      visibilities,
    ],
    () =>
      Api.getPosts({
        assigneeId,
        authorId,
        extraParams,
        iVotedFor,
        limit,
        page,
        parentId: post?.id || parentId,
        search,
        sort,
        status,
        tags,
        types,
        visibilities,
      }),
    {
      enabled: !!space.id,
      select: (response: any) => response.data,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      ...useQueryProps,
    },
  );

  const posts: Post[] = (data?.data || []) as Post[];

  return {
    posts,
    paging: data?.paging || { total: 0 },
    postsCount: data?.paging?.total || 0,
    ...params,
  };
};

export default usePostsQuery;
